import Vue from "vue";
import { VApp, VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent } from "vuetify/lib";

Vue.component("v-app", VApp);
Vue.component("v-expansion-panels", VExpansionPanels);
Vue.component("v-expansion-panel", VExpansionPanel);
Vue.component("v-expansion-panel-header", VExpansionPanelHeader);
Vue.component("v-expansion-panel-content", VExpansionPanelContent);

export default {};
